// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9ab66b8a","77":"5e3f671b","453":"13197170","562":"7be4ed77","864":"d737b685","952":"8a63f18b"}[chunkId] + ".chunk.js";
};